
import { defineComponent, PropType, onMounted } from 'vue'

export type TabView = {id: string, label?: string}

export default defineComponent({
  name: 'TabNav',
  emits: ['update:active', 'deactivate'],
  props: {
    views: {
      type: Array as PropType<Array<TabView>>,
      required: true
    },
    active: {
      type: Object as PropType<TabView>
    },
    bigNav: {
      type: Boolean,
      default: false
    },
    hideInactive: {
      type: Boolean,
      default: true
    }
  },
  setup (props, {emit}) {

    function switchTab (tab:TabView) {
      emit('deactivate', props.active)
      emit('update:active', tab)
    }

    onMounted(() => {
      if (!props.active)  emit('update:active', props.views[0])
    })

    return { switchTab }
  },
})
